import { render, staticRenderFns } from "./nonPlush.vue?vue&type=template&id=4fdf5a70&scoped=true&"
import script from "./nonPlush.vue?vue&type=script&lang=js&"
export * from "./nonPlush.vue?vue&type=script&lang=js&"
import style0 from "./nonPlush.vue?vue&type=style&index=0&id=4fdf5a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdf5a70",
  null
  
)

export default component.exports